import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import subscriptionService from '../../services/subscription-service';
import './SubscriptionBanner.scss';

const SubscriptionBanner = ({ visible = true, isTrialEligible = false }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [offerSettings, setOfferSettings] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    loadOfferSettings();
  }, []);

  const loadOfferSettings = async () => {
    try {
      const plans = await subscriptionService.getSubscriptionPlans();
      if (plans.length > 0 && plans[0].offerSettings) {
        setOfferSettings(plans[0].offerSettings);
      }
    } catch (error) {
      console.error('Error loading offer settings:', error);
    }
  };

  if (!isVisible) return null;

  const showOffer = offerSettings?.showOffer && !isTrialEligible;

  return (
    <div className={`subscription-banner ${visible ? 'banner-visible' : 'banner-hidden'} ${showOffer ? 'offer-banner' : ''}`}>
      <div className="banner-content">
        <span className="banner-icon">{isTrialEligible ? '🎁' : showOffer ? '🎉' : '🌿'}</span>
        <span className="banner-text">
          {showOffer ? (
            <strong>🎉 {offerSettings.offerName} - {offerSettings.discountPercentage}% OFF on Booster Plan!</strong>
          ) : (
            <strong>Subscribe & Save — Fresh organic nutrition Mon–Fri</strong>
          )}
        </span>
        <button className="banner-cta" onClick={() => navigate('/subscriptions')}>
          {isTrialEligible ? 'Claim Free Trial' : showOffer ? 'Subscribe Now' : 'View Plans'}
        </button>
      </div>
      <button className="banner-close" onClick={() => setIsVisible(false)}>
        ×
      </button>
    </div>
  );
};

export default SubscriptionBanner;
